import {FormModalState} from "../types/FormModalState";

export const state: FormModalState = {
    elements: []
}